import { render, staticRenderFns } from "./PageEditorMarkdown.vue?vue&type=template&id=4e561725"
import script from "./PageEditorMarkdown.vue?vue&type=script&lang=js"
export * from "./PageEditorMarkdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports